import { render, staticRenderFns } from "./InfoVisit.vue?vue&type=template&id=34a11430&scoped=true&"
import script from "./InfoVisit.vue?vue&type=script&lang=js&"
export * from "./InfoVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a11430",
  null
  
)

export default component.exports